import { Configuration, PopupRequest } from "@azure/msal-browser";

const prodClientId = "fc50c8c2-00d9-472d-a26a-0756d8638942"; // PROD
const devClientId = "ff384b08-6729-4b4e-ae4a-f8d5f64865d1"; // DEV
const clientId = prodClientId;

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId,
    redirectUri: "/",
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: "/",
    authority:
      "https://login.microsoftonline.com/762650ea-4240-42e1-b537-25e4e435ae49", // 'https://login.microsoftonline.com/8b2c10d6-b78e-4281-b4f0-6276b326ad8e' /*FINLABS*/
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: [`${clientId}/.default`],
};
